import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import QualysPolicyComplianceConfigListing from "./QualysPolicyComplianceConfigListing";
import QualysPolicyComplianceCredentialsForm from "./QualysPolicyComplianceCredentialsForm";

const QualysPolicyCompliancePullAndPushView = (props) => (
  <GenericPullAndPushToolView
    {...props}
    PullCredentialForm={QualysPolicyComplianceCredentialsForm}
    PullConfigListingView={QualysPolicyComplianceConfigListing}
  />
);

export default QualysPolicyCompliancePullAndPushView;
